export const Typography = {
    weight: {
        light: 300,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
    lineHeight: {
        // rem
        ui: 1,
        text: 1.5,
        display: 1.25
    },
    fontSize: {
        //desktop
        ui_xxs: '10px',
        ui_xs: '12px',
        ui_s: '14px',
        ui_m: '16px',
        iu_l: '18px',
        ui_xl: '20px',

        //mobile
        text_xxs_mobile: '0',
        text_xs_mobile: '0',
        text_md_mobile: '0',
        text_lg_mobile: '0',
        text_xl_mobilet: '0',
        text_xxl_mobile: '0',

        display_xs_mobile: '0',
        display_s_mobile: '0',
        display_m_mobile: '0',
        display_l_mobile: '0',
        display_xl_mobile: '0',
        display_xxl_mobile: '0',

        //tablet
        text_xxs_tablet: '0',
        text_xs_tablet: '0',
        text_md_tablet: '0',
        text_lg_tablet: '0',
        text_xl_tablet: '0',
        text_xxl_tablet: '0',

        display_xs_tablet: '0',
        display_s_tablet: '0',
        display_m_tablet: '0',
        display_l_tablet: '0',
        display_xl_tablet: '0',
        display_xxl_tablet: '0',

        // text_xxs_desktop: '12px',
        // text_xs_desktop: '0.4vw',
        // text_md_desktop: '0.7vw',
        // text_lg_desktop: '0.9vw',
        // text_xl_desktop: '1vw',
        // text_xxl_desktop: '1.2vw',

        //videowall
        text_xxs_desktop: '10px',
        text_xs_desktop: '10px',
        text_md_desktop: '9px',//In Cascais (7680x2169) = 36.0px,
        text_lg_desktop: '12px',//In Cascais (7680x2169) = 42.0px,
        text_xl_desktop: '16px',//In Cascais (7680x2169) = 48.0px,
        text_xxl_desktop: '20px', //In Cascais (7680x2169) = 54.0px,
        text_xxxl_desktop: '26px',

        display_xs_desktop: '40px',
        display_s_desktop: '48px',
        display_m_desktop: '56px',
        display_l_desktop: '64px',
        display_xl_desktop: '72px',
        display_xxl_desktop: '80px',

        //videowall
        text_xxs_videowall: '0',
        text_xs_videowall: '0',
        text_md_videowall: '0.469vw',//In Cascais (7680x2169) = 36.0px,
        text_lg_videowall: '0.547vw',//In Cascais (7680x2169) = 42.0px,
        text_xl_videowall: '0.625vw',//In Cascais (7680x2169) = 48.0px,
        text_xxl_videowall: '0.704vw', //In Cascais (7680x2169) = 54.0px,
        text_xxxl_videowall: '1.042vw', //In Cascais (7680x2169) = 80.0px,
    }, 
};
